import * as Sentry from '@sentry/nextjs';

// Sentry stays opt-in: when NEXT_PUBLIC_SENTRY_DSN is unset the SDK no-ops,
// so dev runs and untouched preview deploys don't ship telemetry.
//
// Replay PII safety: every JS error captures a DOM snapshot. For dealers
// that includes their pricing and cart; for admins, the customer-pricing
// tools and order queue. Mask all text and inputs (and block media) at
// the integration level so we never accidentally exfiltrate customer
// data through the replay payload. If we ever need un-masked replay for
// a specific UI bug, opt elements in with Sentry's `unmask`/`unblock`
// selectors rather than turning masking off globally.
Sentry.init({
  dsn: process.env['NEXT_PUBLIC_SENTRY_DSN'],
  enabled: Boolean(process.env['NEXT_PUBLIC_SENTRY_DSN']),
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
});
